import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import { C_Select } from '../../CustomValidateForm';
import { MetaTags } from 'react-meta-tags';
import * as _cfunc from "../../components/Common/CommonFunction";
import { C_Button, PageLoadingSpinner } from '../../components/Common/CommonButton';
import { commonPageField, commonPageFieldListSuccess, commonPageFieldSuccess, getpdfReportdataSuccess, GetVenderSupplierCustomer, GetVenderSupplierCustomerSuccess } from '../../store/actions';
import { BillBooking_Report_Action_Success } from '../../store/Report/BillBookingRedux/action';
import { mode, pageId, url } from '../../routes';
import * as report from '../../Reports/ReportIndex'
import Data from './data.json';
import C_Report from '../../components/Common/C_Report';
import DynamicColumnHook from '../../components/Common/TableCommonFunc';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import GlobalCustomTable from '../../GlobalCustomTable';
import { BillProcessingFilter_Action, BillProcessingFilter_Action_Success, BillProcessingReport_Action, BillProcessingReport_Action_Success } from '../../store/Report/BillProcessingReport/action';
import { customAlert } from '../../CustomAlert/ConfirmDialog';
import { alertMessages } from '../../components/Common/CommonErrorMsg/alertMsg';
import { Bill_Processing_Api } from '../../helpers/backend_helper';
import CommonPurchaseList from '../../components/Common/CommonPurchaseList';
import { allLabelWithZero } from '../../components/Common/CommonErrorMsg/HarderCodeData';


function BillProcessingReport(props) {
    const dispatch = useDispatch();
    const history = useHistory();


    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)
    const selectedMonth = () => _cfunc.getPreviousMonthAndYear({ date: new Date(), Privious: 0 })
    // const IsMannagementParty = !_cfunc.loginUserIsFranchisesRole() && _cfunc.loginIsSCMParty();
    const IsMannagementParty = _cfunc.isAdminDivisionRole();
    const [PartyDropdown, setPartyDropdown] = useState();
    const [selectedCustomer, setSelectedCustomer] = useState(allLabelWithZero);
    const [processloading, setProcessloading] = useState(false);
    const [SelectedMonth, setSelectedMonth] = useState(selectedMonth());
    const [userPageAccessState, setUserAccState] = useState('');
    // const [tableData, setTableData] = useState([]);

    const reducers = useSelector((state) => ({
        Customer: state.CommonAPI_Reducer.vendorSupplierCustomer,
        listBtnLoading: state.BillDeleteSummaryReportReducer.listBtnLoading || state.BillProcessingReportReducer.listBtnLoading,
        partyDropdownLoading: state.CommonPartyDropdownReducer.partyDropdownLoading,
        Party: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        userAccess: state.Login.RoleAccessUpdateData,
        tableList: state.BillProcessingReportReducer.BillProcessingFilterData,
        BillProcessingReportData: state.BillProcessingReportReducer.BillProcessingReportData,
        pageField: state.CommonPageFieldReducer.pageField,
        CustomerDropLoading: state.CommonAPI_Reducer.vendorSupplierCustomerLoading,
    }));

    // const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);

    const {
        partyDropdownLoading,
        Party,
        Customer,
        CustomerDropLoading,
        pageField,
        userAccess,
        listBtnLoading,
        BillProcessingReportData
    } = reducers

    useEffect(() => {
        dispatch(commonPageFieldListSuccess(null));
        dispatch(commonPageField(pageId.BILL_PROCESSING_REPORT));
        dispatch(GetVenderSupplierCustomerSuccess([]));
        dispatch(GetVenderSupplierCustomer({ subPageMode: url.BILL_PROCESSING_REPORT, PartyID: _cfunc.loginSelectedPartyID() }));
        return () => {
            dispatch(GetVenderSupplierCustomerSuccess([]));
            dispatch(BillProcessingFilter_Action_Success([]));
            dispatch(BillBooking_Report_Action_Success([]));
        }
    }, []);

    const action = {}

    function MonthAndYearOnchange(e) {
        const selectedMonth = e.target.value
        setSelectedMonth(selectedMonth);
    }


    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })
        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    useEffect(() => {

        if (BillProcessingReportData.StatusCode === 200 && BillProcessingReportData.Status === true) {
            dispatch(BillProcessingReport_Action_Success({ Status: false }))

            BillProcessingReportData["ReportType"] = report.Bill_Processing_Report
            dispatch(getpdfReportdataSuccess(BillProcessingReportData))

        } else if (BillProcessingReportData.Status === true) {
            customAlert({ Type: 3, Message: BillProcessingReportData.Message })
        }

    }, [BillProcessingReportData])


    const CustomerOptions = (Customer || []).map((party) => ({
        label: party.Name,
        value: party.id,
    }));
    CustomerOptions.unshift(allLabelWithZero)


    const Party_Option = Party.map(i => ({
        value: i.id,
        label: i.Name,

    }))

    const PartyDrodownOnChange = (e) => {
        setPartyDropdown(e);
        dispatch(GetVenderSupplierCustomer({ subPageMode: url.BILL_PROCESSING_REPORT, PartyID: e.value }));

    };
    // const [tableColumns] = DynamicColumnHook({ pageField, })


    const ProcessHandler = async () => {
        const [year, month] = SelectedMonth.split("-");
        setProcessloading(true)
        const config = {
            jsonBody: JSON.stringify({
                Month: Number(month),
                Party: (IsMannagementParty && PartyDropdown) ? PartyDropdown.value : _cfunc.loginSelectedPartyID(),
                Customer: (selectedCustomer) ? selectedCustomer.value : 0,
                Year: Number(year)
            })
        }
        const Resp = await Bill_Processing_Api(config);

        if (Resp.StatusCode === 200 && Resp.Status === true) {
            setProcessloading(false)
            customAlert({ Type: 1, Message: Resp.Message })
        } else if (Resp.Status === true) {
            setProcessloading(false)
            customAlert({ Type: 3, Message: Resp.Message })
        }
        setProcessloading(false)

    }

    function downBtnFunc({ rowData }) {

        const [year, month] = SelectedMonth.split("-");
        const config = {
            jsonBody: JSON.stringify({
                Month: Number(month),
                Party: rowData.Party,
                Customer: rowData.Customer,
                Year: Number(year)
            }), btnId: `btn-download-${rowData.Customer}`
        }
        dispatch(BillProcessingReport_Action(config));
    }
    const goButtonHandler = (Type) => {
        
        if ((IsMannagementParty && PartyDropdown)) {
            if (!PartyDropdown) {
                customAlert({ Type: 3, Message: alertMessages.selectPartyName })
                return
            }
        }

        if (!selectedCustomer) {
            customAlert({ Type: 3, Message: alertMessages.selectCustomerName })
            return
        }

        const [year, month] = SelectedMonth.split("-");

        const config = {
            jsonBody: JSON.stringify({
                Month: Number(month),
                Party: (IsMannagementParty && PartyDropdown) ? PartyDropdown.value : _cfunc.loginSelectedPartyID(),
                Customer: (selectedCustomer) ? selectedCustomer.value : 0,
                Year: Number(year)
            }), Type
        }

        // dispatch(BillProcessingReport_Action(config));

        dispatch(BillProcessingFilter_Action(config));

    }


    const HeaderContent = () => {
        return (
            <div className="px-2   c_card_filter text-black" >
                <div className="row" >
                    <Row>
                        <Col sm={3}>
                            <FormGroup className="mb- row mt-2" >
                                <Label style={{ width: "83px" }} className="col-sm-1 p-2 ">Month</Label>
                                <Col sm={8}>
                                    <Input className="form-control"
                                        type="month"
                                        defaultValue={SelectedMonth}
                                        id="example-month-input"
                                        onChange={MonthAndYearOnchange}
                                    // max={currentMonth}
                                    />
                                </Col>
                            </FormGroup>


                        </Col>

                        {IsMannagementParty && < Col sm={3}>
                            <FormGroup className=" row mt-2" >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "65px", marginRight: "20px" }}>Party</Label>
                                <Col sm="8">
                                    <C_Select
                                        name="Party"
                                        value={PartyDropdown}
                                        isSearchable={true}
                                        isLoading={partyDropdownLoading}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                        options={Party_Option}
                                        onChange={PartyDrodownOnChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        }

                        <Col lg={3}>
                            <FormGroup className="mb-2 row mt-2 " >
                                <Label className="col-md-4 p-2"

                                    style={{ width: "65px", marginRight: "20px" }}>Customer</Label>
                                <Col sm="8">
                                    <C_Select
                                        name="Customer"
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        placeholder="Select"
                                        value={selectedCustomer}
                                        isLoading={CustomerDropLoading}

                                        styles={{
                                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                                        }}
                                        options={CustomerOptions}
                                        onChange={(e) => { setSelectedCustomer(e) }}
                                    />
                                </Col>
                            </FormGroup>

                        </Col >

                        <Col className=" d-flex justify-content-end " >
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={processloading}
                                className="btn btn-primary m-3 mr "
                                onClick={() => ProcessHandler()}
                            >
                                Bill Process
                            </C_Button>
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={listBtnLoading === "showOnTable"}
                                className="btn btn-success m-3 mr"
                                onClick={() => goButtonHandler("showOnTable")}
                            >
                                GO
                            </C_Button>
                            {/* <C_Button
                                    type="button"
                                    spinnerColor="white"
                                    loading={listBtnLoading === "Print"}
                                    className="btn btn-primary m-3 mr "
                                    onClick={() => goButtonHandler("Print")}
                                >
                                    Print
                                </C_Button> */}


                        </Col>
                    </Row>
                </div>

            </div>
        )
    }




    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={!pageField} />
            <div className="page-content">
                {
                    (pageField) &&
                    <div className="mt-n1">
                        <CommonPurchaseList
                            action={action}
                            reducers={reducers}
                            downBtnFunc={downBtnFunc}
                            pageMode={mode.defaultList}
                            HeaderContent={HeaderContent}
                            goButnFunc={goButtonHandler}

                        />
                    </div>
                }
            </div>

        </React.Fragment>
    )
}

export default BillProcessingReport